import type { Token, Tokens } from 'marked';

export const PAREN_LIST_TOKEN_NAME = 'paren_list';

export interface ParenListItem {
  /** The author's original marker character, e.g. `a` in `a) first`. */
  marker: string;
  /** Item body with the `x)` marker stripped. */
  text: string;
}

export interface ParenListToken extends Tokens.Generic {
  type: typeof PAREN_LIST_TOKEN_NAME;
  raw: string;
  items: ParenListItem[];
}

export function isParenListToken(token: Token): token is ParenListToken {
  if (token.type !== PAREN_LIST_TOKEN_NAME) {
    return false;
  }

  return 'items' in token && Array.isArray(token.items);
}
